import { Client, Layout, Message } from "dashboard-assistant";

function escapeHtml(text: string) {
    let div = document.createElement('div');
    div.innerText = text;
    return div.innerHTML;
}

export class Chat {
    client: Client;
    messages: Message[];
    assistant_hook: (layout: Layout | null) => void;

    constructor(path: string) {
        this.client = new Client(location.protocol + '//' + location.host + "/" + path);
        this.messages = [];
        this.assistant_hook = (layout: Layout | null) => { };
    }

    async send(): Promise<void> {
        const prompt = document.getElementById("prompt")! as HTMLTextAreaElement;
        const user_text = prompt.value;
        prompt.value = ""

        const history = document.getElementById("history")!;
        const msg: Message = { role: "user", content: { text: user_text } };
        this.messages.push(msg);
        history.innerHTML += "<h3>User</h3>";
        history.innerHTML += escapeHtml(user_text);

        let button = document.getElementById("send")! as HTMLButtonElement;
        button.disabled = true;

        try {
            const reply = await this.client.ask({ messages: this.messages });

            history.innerHTML += "<h3>Assistant</h3>";
            history.innerHTML += escapeHtml(reply.text);
            if (reply.dashboard) {
                this.assistant_hook(reply.dashboard);
            } else {
                this.assistant_hook(null);
            }

            this.messages.push({ role: "assistant", content: reply });
        } catch (e) {
            history.innerHTML += `<h3 style="color:#ff0000">Assistant error</h3><div style="color:#ff0000">${escapeHtml(e.message)}</div>`;
        }

        button.disabled = false;
    }

    register() {
        document.getElementById("send")!.addEventListener("click", () => this.send());
    }
}
